import React, { FC } from 'react'
import { Typography } from 'react-components'
import { CTAButton, StyledGhostButton } from '../styles'
import { ShareIconWrapper } from './styles'
import { FormattedBookingTypeData } from '../../../models/property-details-page/booking-type-model'
import { SearchbarFieldsReturn } from '../hooks/use-searchbar'
import get from 'lodash/get'
import isInquiryButtonVisible from '../side-bar/utils/is-inquiry-button-visible'
import getChildrenAges from '../utils/get-children-ages'
import useDynamicQueryParams from '../hooks/use-dynamic-query-params'
import AnalyticsService from '../../../services/analytics-service'
import { pdpPageActions } from '../../../services/analytics-service/actions'
import { getSearchDate } from '../../../utils/miscellaneous-utils'
import updateDateRetentionCookies from '../utils/update-date-retention-cookies'
import { ThunderPickerIcon } from '../../search-result-listing/header-section/searchbar/widget-styles'
import { useTranslation } from '../../../hooks/locale'
import { PdpToCheckoutPosition } from '../constants'
import { usePropertyDetailsContext } from '../../../hooks/property-details'
import { getCategory } from '../../../utils/category-utils'
import { useRouter } from 'next/router'

type BookNowButtonProps = {
    bookingType: FormattedBookingTypeData | null
    searchbar: SearchbarFieldsReturn
    showShortTitle?: boolean
    position:
        | PdpToCheckoutPosition.GALLERY
        | PdpToCheckoutPosition.GALLERY_FOOTER
        | PdpToCheckoutPosition.SIDEBAR
        | PdpToCheckoutPosition.STICKY_FOOTER
        | PdpToCheckoutPosition.PRICE_WIDGET
        | PdpToCheckoutPosition.COMBO_LISTING_POPUP
}

const BookNowButton: FC<BookNowButtonProps> = props => {
    const { bookingType, searchbar, position, showShortTitle = false } = props
    const { query } = useRouter()
    const dynamicQueryParams = JSON.parse(get(bookingType, 'dynamicQueryParams', '') || '')
    const childrenAges = getChildrenAges(searchbar.kids)
    const qpValues = { ...query, ...searchbar, childrenAges }
    const url = useDynamicQueryParams(bookingType, qpValues, dynamicQueryParams)
    const isPrimary = !isInquiryButtonVisible({ bookingType })
    const type = get(bookingType, 'type')
    const titleKey = showShortTitle ? 'shortTitle' : 'title'
    const { t } = useTranslation()
    const { isComboListing } = usePropertyDetailsContext()

    const onBookNowClick = (event: React.MouseEvent) => {
        AnalyticsService.trackEvent({
            category: getCategory(isComboListing),
            action: pdpPageActions.BOOK_NOW_BUTTON_CLICKED,
            label: position,
        })
        const arrival = getSearchDate(searchbar.arrival)
        const departure = getSearchDate(searchbar.departure)
        const adultsCount = searchbar.adults
        const childrenCount = searchbar.kids
        updateDateRetentionCookies(arrival, departure, adultsCount, childrenCount, searchbar.location)
        if (type === 'redirect') {
            event.preventDefault()
            window.open(url, '_blank')
        } else {
            window.location.href = url
        }
    }

    return (
        <CTAButton onClick={onBookNowClick}>
            <StyledGhostButton isPrimary={isPrimary} buttonSize="large">
                <ShareIconWrapper isPrimary={isPrimary}>
                    <ThunderPickerIcon alt={t('thunderIconText')} style={{ position: 'unset' }} />
                </ShareIconWrapper>
                <Typography variant="subtitle2" fontWeight="semiBold">
                    {get(bookingType, titleKey)}
                </Typography>
            </StyledGhostButton>
        </CTAButton>
    )
}

export default BookNowButton
